<template>
  <div id="app">
    <div id="map" class="map"></div>
    <NodeDetailsModal ref="NodeDetailsModalRef" @ok="callback" />
    <PipelineDetailsModal ref="PipelineDetailsModalRef" @ok="callback" />
  </div>
</template>

<script>
import 'ol/ol.css'
import Map from 'ol/Map'
import View from 'ol/View'
import { get as getProjection, fromLonLat, toLonLat } from 'ol/proj'
import { getWMTSExtent } from '../module/comFunction/GetCapabilities.js'
import { createLayerEm_topology_node_pipeline } from '../module/layers/Em_topology_node_pipeline.js'
import { createLayerEM_MAP_ALL_18 } from '../module/layers/EM_MAP_ALL_18_DARK.js'
import { createLayerTp_node } from '../module/layers/Tp_node.js'
import { createLayerTp_pipeline } from '../module/layers/Tp_pipeline.js'
import { createLayerTp_area } from '../module/layers/Tp_area.js'
import { createGetFeatureInfo } from '../module/comFunction/WmsGetFeatureInfo.js'
import { parseHexWKB, zoomToPoint, zoomToLine } from '../module/comFunction/ComFunction.js'
import { Vector as VectorLayer } from 'ol/layer'
import { Vector as VectorSource } from 'ol/source'
import { vectorStyle } from '../module/style/VectorStyle.js'
import { TestNode, TestLine1, TestLine2, TestLine3 } from '../module/source/NodeOrPipLine.js'
import { Feature } from 'ol'
import NodeDetailsModal from './components/NodeDetailsModal.vue'//节点属性编辑
import PipelineDetailsModal from './components/PipelineDetailsModal.vue'//管道属性编辑
import Vue from 'vue'
import ScaleLine from 'ol/control/ScaleLine'
import { getPostGreSqlNodeInfoByCode, getPostGreSqlLineInfoByCode } from '../module/comFunction/ApiFunction.js'
import {filterDictTextByCache} from '@/components/dict/JDictSelectUtil'
import CONFIG from '../module/config/GIS_Config'

export default {
  name: 'App',
  components: {
    NodeDetailsModal,
    PipelineDetailsModal,
  },
  data() {
    return {
      map: {},
      tileLayer: {},
      baseLayer: {},
      nodeLayerNode: {},
      pipeLineLayer: {},
      areaLayer: {},
      highlightLayer: {}, // 高亮矢量图层
      tileSource: {},
      view: {},
      resolutions: [],
      matrixIds: [],
      projection: '',
      currentRow: {},
      disabled: true,
      visible: false,
      zoomLevel: 0, //
      topology: '', // 全局拓扑参数
      scaleDisplayInterval: null, // 比例尺更新定时器
    }
  },
  created(){
    let query = JSON.parse(this.$route.query.arg);
    if(query.id){
      this.disabled = query.disabled;
      this.currentRow = {
        project_code: query.projectCode,
        topology_code: query.code,
      }
    }else{
      this.disabled = true;
      this.currentRow = {}
    }
  },
  mounted() {
    this.$nextTick(()=>{
      this.initMap()
      // 新增点击事件监听
      this.map.on('click', this.handleMapClick)
      // 添加高亮图层
      this.initHighlightLayer()
      this.map.addLayer(this.highlightLayer)
      // 添加定时器，用于更新图层参数
      this.setupScaleDisplay()
    })
  },
  beforeDestroy() {
    // 清除定时器
    if (this.scaleDisplayInterval) {
      clearInterval(this.scaleDisplayInterval)
    }
  },
  methods: {
    initMap() {
      // 1. 投影配置 编码
      this.projection = getProjection(CONFIG.PROJECTION)

      // 4. 瓦片图层配置
      // let tileLayer = new TileLayer({ source: wmtsSource })
      this.tileLayer = createLayerEm_topology_node_pipeline()
      // 底图
      this.baseLayer = createLayerEM_MAP_ALL_18()
      // 点 图层
      this.nodeLayerNode = createLayerTp_node()
      // 线图层
      this.pipeLineLayer = createLayerTp_pipeline()
      this.areaLayer = createLayerTp_area()
      this.tileSource = this.tileLayer.getSource()
      // 从 WMTS 图层元数据中获取范围（假设服务端提供）
      let wmtsLayerExtent = CONFIG.DEFAULT_EXTENT

      // 2. 动态计算中心点
      const center = [
        (wmtsLayerExtent[0] + wmtsLayerExtent[2]) / 2, // 经度平均值
        (wmtsLayerExtent[1] + wmtsLayerExtent[3]) / 2, // 纬度平均值
      ]

      // 3. 转换为投影坐标系
      const projectedCenter = fromLonLat(center)
      const projectedExtent = [
        ...fromLonLat([wmtsLayerExtent[0], wmtsLayerExtent[1]]),
        ...fromLonLat([wmtsLayerExtent[2], wmtsLayerExtent[3]]),
      ].flat()

      // 4. 创建视图
      this.view = new View({
        center: projectedCenter,
        zoom: 11,
        projection: this.projection,
        // extent: projectedExtent, // 动态设置视图范围
      })

      // 7. 创建地图实例
      this.map = new Map({
        target: 'map',
        layers: [this.baseLayer, this.pipeLineLayer, this.nodeLayerNode],
        view: this.view,
        // 添加比例尺控件
        controls: [
          // 其他控件...
          new ScaleLine({
            className: 'ol-scale-line', // 自定义类名，用于样式覆盖
            units: 'metric', // 公制单位（米、公里）
            bar: true, // 使用条形比例尺（横向线段）
            steps: 2, // 比例尺分段数，这里设置为4段（默认是4，也可以不设置）
            text: true, // 显示比例尺文本
            minWidth: 100, // 最小宽度（像素）
          }),
        ],
      })
      // +++ 新增：使用fit方法设置初始范围 +++
      this.$nextTick(() => {
        this.map.getView().fit(projectedExtent, {
          padding: [20, 20, 20, 20], // 添加适当的内边距
          duration: 0, // 立即生效
        })
      })
    },
    // 初始化高亮图层
    initHighlightLayer() {
      this.highlightLayer = new VectorLayer({
        source: new VectorSource(),
        style: feature => vectorStyle(feature), // 使用函数样式
        zIndex: 9999, // 确保在最上层
      })
    },
    // 点击事件 获取点 线 信息
    async handleMapClick(evt) {
      console.log('点击左键evt属性:', evt)
      const coordinate = evt.coordinate
      const view = this.map.getView()
      const resolution = view.getResolution()
      const projection = view.getProjection()

      try {
        const layers = [
          { layer: this.nodeLayerNode, name: 'tp_node_sql' },
          { layer: this.pipeLineLayer, name: 'tp_pipeline_sql' },
        ]

        const results = await Promise.all(
          layers.map(async layerInfo => {
            const info = await createGetFeatureInfo({
              map: this.map,
              coordinate,
              layer: layerInfo.layer,
              layerName: layerInfo.name,
              resolution,
              projection,
            })
            return { ...layerInfo, info }
          })
        )
        console.log('所有图层结果:', results)
        if(results[0].info.features.length>0){
          var node = Object.assign({},results[0].info.features[0].properties,{id: results[0].info.features[0].id});
          this.$refs.NodeDetailsModalRef.init(Object.assign({},node,this.currentRow));
          this.$refs.NodeDetailsModalRef.disableSubmit = this.disabled;
        }else{
          var node = Object.assign({},results[1].info.features[0].properties,{id: results[1].info.features[0].id});
          this.$refs.PipelineDetailsModalRef.init(Object.assign({},node,this.currentRow));
          this.$refs.PipelineDetailsModalRef.disableSubmit = this.disabled;
        }
        // 处理所有图层的结果
        results.forEach(result => {
          if (result.info && result.info.features.length > 0) {
            console.log(`${result.name} 图层属性:`, result.info.features)
            result.info.features.forEach(feature => {
              console.log('详细属性:', feature.properties)
            })
          }
        })
      } catch (error) {
        console.error('WMS查询失败:', error)
      }
    },
    async getNodeInfo(code) {
      if (code == null) return null
      let parm = {
        projectCode: CONFIG.TopologyProjection,
        topologyCode: CONFIG.TopologyCode,
        code: code,
        name: null,
      }
      try {
        const res = await getPostGreSqlNodeInfoByCode(parm)
        if (res.success) {
          console.log('当前线信息', res.result)
          return res.result
        } else {
          return null
        }
      } catch (error) {
        console.error('获取线信息失败:', error)
        return null
      }
    },
    async getLineInfo(code) {
      if (code == null) return null
      let parm = {
        projectCode: CONFIG.TopologyProjection,
        topologyCode: CONFIG.TopologyCode,
        code: code,
        name: null,
      }
      try {
        const res = await getPostGreSqlLineInfoByCode(parm)
        if (res.success) {
          console.log('当前线信息', res.result)
          return res.result
        } else {
          return null
        }
      } catch (error) {
        console.error('获取线信息失败:', error)
        return null
      }
    },
    parseAndHighLight(item) {
      if (item == null) return
      // 解析十六进制geometry坐标。
      const geometry = parseHexWKB(item.geometry, 'EPSG:3857', 'EPSG:3857')
      if (!geometry) return

      // 清除之前的高亮要素
      const highlightSource = this.highlightLayer.getSource()
      highlightSource.clear()

      // 创建新要素并添加到高亮图层
      const feature = new Feature({
        geometry: geometry,
        featureType: item.id.startsWith('line') ? 'line' : 'point', // 标识类型
      })
      highlightSource.addFeature(feature)
      return geometry
    },
    setupScaleDisplay() {
      // 初始化缩放层级
      this.updateZoomLevel()

      // 添加地图缩放监听
      this.map.getView().on('change:resolution', () => {
        this.updateZoomLevel()
      })
      // 定期更新图层参数
      this.scaleDisplayInterval = setInterval(() => {
        this.updateLayerParams()
      }, 500)
    },
    // +++ 新增：更新缩放层级 +++
    updateZoomLevel() {
      if (this.map && this.map.getView()) {
        const currentZoom = this.map.getView().getZoom()
        // 四舍五入到整数（如果需要小数可以去掉）
        this.zoomLevel = Math.round(currentZoom)
      }
    },
    // 更新所有图层的参数
    updateLayerParams() {
      // 更新拓扑参数（如果缓存有变化）
      // 更新所有图层的参数
      const layers = [this.nodeLayerNode, this.pipeLineLayer, this.areaLayer]

      layers.forEach(layer => {
        if (layer && layer.getSource()) {
          layer.getSource().updateParams({
            VIEWPARAMS:
              'projectCode:' +
              CONFIG.TopologyProjection +
              ';topologyCode:' +
              CONFIG.TopologyCode +
              ';zoomLevel:' +
              this.zoomLevel,
          })

          // 强制刷新图层（解决缓存问题）
          layer.getSource().refresh()
        }
      })
    },
    refreshPipelineLayer() {
      const source = this.pipeLineLayer.getSource()
      source.updateParams({
        STYLES: 'Dynamic_Pipeline_Style',
        t: Date.now(), // 防止缓存
      })
      this.$nextTick(() => {
        this.map.updateSize()
      })
    },
  },
}
</script>

<style>
#map {
  width: 100%;
  height: 80vh;
}
/* +++ 新增比例尺样式 +++ */
/* 自定义比例尺控件样式 */
.ol-scale-line {
  background: rgba(255, 255, 255, 0.5); /* 半透明白色背景 */
  border-radius: 4px;
  bottom: 8px;
  left: 8px; /* 默认在左下角，可以调整位置 */
  padding: 2px;
  position: absolute;
}

.ol-scale-line-inner {
  border: 1px solid #333;
  border-top: none;
  color: #333;
  font-size: 10px;
  text-align: center;
  margin: 1px;
  will-change: contents, width;
  transition: all 0.25s;
  /* 禁止用户选择文本 */
  user-select: none;
  pointer-events: none;
}

/* 如果想要将比例尺放在右下角，可以这样调整 */
.ol-scale-line {
  left: auto;
  right: 8px;
}
</style>
